module.exports = __webpack_public_path__ + "static/media/logoDark.d105278b.png";